import { photoPlugin } from '@adsk/acc-sitevision-web-lib';

export default photoPlugin;
